import { render, staticRenderFns } from "./SearchSuccess.vue?vue&type=template&id=f6163b5a&scoped=true&"
import script from "./SearchSuccess.vue?vue&type=script&lang=ts&"
export * from "./SearchSuccess.vue?vue&type=script&lang=ts&"
import style0 from "./SearchSuccess.vue?vue&type=style&index=0&id=f6163b5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6163b5a",
  null
  
)

export default component.exports